let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let ApplyListModal = require("../main_view/event_area/tabs/action_list/ApplyListModal");

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return {
      event_to_apply: null
    };
  },
  Radio_setup() {
    return {
      PromptApplyActionList_set_event_to_apply(event) {
        this.setState({event_to_apply: event});
      }
    };
  },
  __close: esUtils.wrapPreventDefault(function () {
    this.setState({event_to_apply: null});
  }),
  render() {
    let event = this.state.event_to_apply;
    let {Displaylists} = this.props;
    let list_id = _.first(event && event.todolistids);
    if (!event || _.isEmpty(list_id)) {
      return dd.div();
    }
    return ApplyListModal({
      event,
      Displaylists,
      list_id: _.parseInt(list_id),
      onClose: this.__close,
      custom_clear_message: "You have a new status set for this event."
    });
  }
});



// WEBPACK FOOTER //
// ./src/components/modals/PromptApplyActionList.js